import AbstractService from '../../vendors/services/abstractService';
import Environment from '../../environments/environment';
import {urlApi} from '../shared/apis/api';
import {TResponseApi} from '../../vendors/@types/httpApi';
import ToastService from '../../vendors/services/toastService';
import {Utils} from '../shared/utils/Utils';

export default class LoginService extends AbstractService {

  constructor() {
    super(urlApi, 'Login');
  }

  public async login(user: string, password: string) {
    const dataSalt: any = await this.getSalt(user);
    if (dataSalt.success) {
      const body = {username: user, password: Utils.encrypt(password, dataSalt.result)};
      return this.api.post(`${this.rota}`, body);
    } else {
      ToastService.showError('Verifique o usuário!');
    }
  }

  public getSalt(user: string) {
    const filterQueryString = new URLSearchParams({user: user}).toString();
    return this.api.get(`${this.rota}/Salt?${filterQueryString}`);
  }

  public async loginUnico(authorizationCode: any, codeVerifier: any): Promise<TResponseApi<any>> {
    return this.api.post(`/LoginUnico`, {
      authorizationCode: authorizationCode,
      codeVerifier: codeVerifier,
      callbackUrl: Environment.getLoginUnicoRedirectUrl()
    });
  }

  public loginSca(token: any) {
    return this.api.get(`${this.rota}/LoginRecover?token=${token}`);
  }

  // public async loginUnico(authorizationCode: any, codeVerifier: any): Promise<TResponseApi<any>> {
  //   const callbackUrl = encodeURIComponent(Environment.getLoginUnicoRedirectUrl());
  //   return this.api.post(
  //     `/LoginUnico/GetTokens?authorizationCode=${authorizationCode}&callbackUrl=${callbackUrl}&codeVerifier=${codeVerifier}`,
  //   );
  // }

  public async loginUnicoConfiabilidades(cpf: any, accesToken: any): Promise<TResponseApi<any>> {
    return this.api.post(`${this.rota}/Confiabilidades?cpf=${cpf}&accessToken=${accesToken}`);
  }

  public async recuperarCnpjsRepresentados(cpf: any, accesToken: any): Promise<TResponseApi<any>> {
    return this.api.post(`${this.rota}/RecuperarCnpjsByCpf?cpf=${cpf}&accessToken=${accesToken}`);
  }

  public async obterPerfisSca(idToken: any, empresa: any): Promise<TResponseApi<any>> {
    const data = {
      cpfUsuario: idToken.sub,
      emailUsuario: idToken.email,
      nomeUsuario: idToken.name,
      telefoneUsuario: idToken.phone_number,
      nivelSeloConfiabilidade: 3,
      cnpjsRepresentados: empresa,
    }
    return this.api.post(`${this.rota}/GetUsuarioPerfis`, data);
  }

  public salvarDadosLoginUnico({dadosLoginUnico, contribuinte}: any) {
    this.authService.save({
      ...dadosLoginUnico.token,
      contribuinte: contribuinte,
      dadosLoginUnico: dadosLoginUnico
    })
  }


  public async getRedirectUrl() {
    const codeChallenge = await this.generateCodeChallengeFromVerifier(
      Environment.getLoginUnicoCodeChallenge(),
    );
    let redirectUrl = '';
    redirectUrl = Environment.getLoginUnicoUrl() + '/authorize';
    redirectUrl += '?response_type=code';
    redirectUrl += '&client_id=' + Environment.getLoginUnicoClientId();
    redirectUrl += '&scope=' + Environment.getLoginUnicoClientAuthScope();
    redirectUrl += '&redirect_uri=' + Environment.getLoginUnicoRedirectUrl();
    redirectUrl += '&nonce=abc';
    redirectUrl += '&state=def';
    redirectUrl += '&code_challenge=' + codeChallenge;
    redirectUrl += '&code_challenge_method=' + 'S256';
    return redirectUrl;
  }

  private async generateCodeChallengeFromVerifier(v: any) {
    const hashed = await this.sha256(v);
    const base64encoded = this.base64urlencode(hashed);
    return base64encoded;
  }

  private sha256(plain: any) {
    const encoder = new TextEncoder();
    const data = encoder.encode(plain);
    return window.crypto.subtle.digest('SHA-256', data);
  }

  private base64urlencode(a: any) {
    let str = '';
    const bytes = new Uint8Array(a);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      str += String.fromCharCode(bytes[i]);
    }
    return btoa(str).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }
}
